const Q = require('q');
const settingsInstance = require('./SettingsInstance');
const { customRequest } = require('./requestHelperNew');

class ApiSessionCache {
  constructor(options = {}) {
    const domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain || settingsInstance.baseApiNewUrl;

    if (!this.domain) {
      throw new Error('Domain parameter must be specified as a string.');
    }

    this.path = '/edit_session_cache';
    this.defaultHeaders = {
      Accept: 'application/json',
      wso2_id: options.wso2_id,
      orgid: options.orgid
    };
  }

  request(
    method,
    {
      body = {},
      queryParameters = {},
      form = {},
      files = {},
      headers = {},
      options = {}
    } = {}
  ) {
    const deferred = Q.defer();
    const url = `${this.domain}${this.path}`;
    const mergedHeaders = { ...this.defaultHeaders, ...headers };

    customRequest(
      method,
      this.path,
      url,
      body,
      mergedHeaders,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  }

  updateCache(body) {
    if (!body) {
      return Promise.reject(new Error('Missing required parameter: body'));
    }

    return this.request('POST', {
      body,
      options: { jsonData: true }
    });
  }

  getCache() {
    return this.request('GET');
  }

  deleteCache() {
    return this.request('DELETE');
  }
}

exports.Api = ApiSessionCache;
